import React from 'react';
import { ChevronDown } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { mockData } from '../mock';

const FAQ = () => {
  return (
    <section id="faq" className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-950">
      <div className="max-w-4xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl font-bold text-white">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-300">
            Find answers to common questions about our NEMT services
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {mockData.faq.map((item) => (
            <AccordionItem 
              key={item.id} 
              value={`item-${item.id}`}
              className="bg-gray-900 border-2 border-gray-800 rounded-lg px-6 hover:border-cyan-500 transition-colors"
            >
              <AccordionTrigger className="text-left text-lg font-semibold text-white hover:text-cyan-400 py-6">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-300 leading-relaxed pb-6">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Contact CTA */}
        <div className="mt-12 text-center bg-gradient-to-r from-cyan-500/10 to-purple-600/10 border-2 border-cyan-500/50 rounded-xl p-8">
          <h3 className="text-2xl font-bold text-white mb-2">
            Still have questions?
          </h3>
          <p className="text-gray-300 mb-6">
            Our team is here to help! Give us a call or send us a message.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={`tel:${mockData.company.phone.replace(/\D/g, '')}`}
              className="inline-flex items-center justify-center px-6 py-3 bg-gradient-to-r from-cyan-500 to-purple-600 hover:from-cyan-600 hover:to-purple-700 text-white font-semibold rounded-lg transition-colors"
            >
              Call {mockData.company.phone}
            </a>
            <a
              href="#contact"
              className="inline-flex items-center justify-center px-6 py-3 bg-transparent hover:bg-cyan-500/10 text-cyan-400 font-semibold rounded-lg border-2 border-cyan-500 transition-colors"
            >
              Send a Message
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
